import React from 'react'
import RoundBlueButton from '../BorderButton/round-blue-button'

import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css'
import { Bootstrap2Toggle } from 'react-bootstrap-toggle'
import { getRegion } from '../../lib/format-dmps'
import ACLCheckPermission from '../ACLCheckPermission'
import CookieTypes from '../CookieTypes'
import PartnerTypes from '../PartnerTypes'
import ReactTooltip from 'react-tooltip'

const SaveButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="saveBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-floppy-o" />} />
)
const SellerButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="sellerBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-users" />} />
)

const RemoveButton = ({ onClick, disabled }) => <RoundBlueButton disabled={disabled} onClick={onClick} icon={<i className="fa fa-trash" />} />

const Row = ({ row, onchange, index, onEdit, onSellerEdit, onRemove, onLoginAs }) => (
    <tr className={`audience-list audience-list--row }`}>
        <td className="audience-list audience-list--audience">
            {row.partnerId}            
        </td>
        <td className="audience-list audience-list--audience">
            {row.friendlyName}
        </td>
        <td className="audience-list audience-list--audience">
            {getRegion(row.region)}
        </td>
        <td className="audience-list audience-list--audience">
            {row.partnerType}
        </td>
        <td className="audience-list audience-list--audience">
            {row.cookieTypes}
        </td>

        <td className="audience-list audience-list--edit">
            <div className="action-wrapper " style={{ justifyContent: 'flex-end' }}>
                <ACLCheckPermission api="/partner" method="PATCH">
                    <ReactTooltip id="saveBtnTooltip" type="dark" effect="solid">
                        <span>Edit partner</span>
                    </ReactTooltip>
                    <button data-tip data-for="saveBtnTooltip" className=" btn btn-sm btn-primary" 
                        onClick={() => onEdit(row)}>
                        <i className="fa fa-pencil" />
                    </button>
                </ACLCheckPermission>



                {!row.new && (
                    <button
                        style={{ 'margin-left': '8px' }}
                        data-tip
                        data-for="loginAsBtnTooltip"
                        className=" btn btn-sm btn-info"
                        onClick={() => onLoginAs(row, index)}>
                        <i className="fa fa-sign-in" />
                    </button>
                )}

                {!row.new && row.partnerType == 'SELLER' && (
                    <div style={{ 'margin-left': '8px' }}>
                        <ReactTooltip id="sellerBtnTooltip" type="dark" effect="solid">
                            <span>Edit Seller Subpartners</span>
                        </ReactTooltip>
                        <button data-tip data-for="sellerBtnTooltip" className=" btn btn-sm btn-info" onClick={() => onSellerEdit(row, index)}>
                            <i className="fa fa-users" />
                        </button>
                    </div>
                )}

                
            </div>
        </td>
    </tr>
)

export default Row
